export const CUSTOM_METRIC_ID_ROOM_DURATION = 'metric1'
export const CUSTOM_METRIC_ID_CHAT_MESSAGE_COUNT = 'metric2'
export const CUSTOM_METRIC_ID_VIDEO_CONNEXION_SUCCESSFUL = 'metric3'
export const CUSTOM_METRIC_ID_VIDEO_CONNEXION_RELAYED = 'metric4'



// WEBPACK FOOTER //
// ./src/constants.js